import React, { FC } from 'react';
import classNames from 'classnames';
import ResolveImage from 'components/ResolveImage';
import { getImgUrl } from 'components/ResolveImage/utils';
import { SIZE, Size } from 'models/Size';
import { useTranslation } from 'react-i18next';

import './BrokerLogo.styles.scss';

type BrokerLogoProps = {
  className?: string;
  size?: Size;
  brokerLogoUrl?: string;
};

const BrokerLogo: FC<BrokerLogoProps> = ({
  className,
  brokerLogoUrl,
  size = SIZE.BIG,
}) => {
  const classes = classNames(
    'broker-logo',
    { 'broker-logo--empty': !brokerLogoUrl },
    size,
    className,
  );

  const { t } = useTranslation();

  if (!brokerLogoUrl) return <div className={classes}>{t('brokerLogo')}</div>;

  return (
    <ResolveImage
      asCompanyLogo
      className={classes}
      src={getImgUrl(brokerLogoUrl, '240')}
    />
  );
};

export default BrokerLogo;
